import { render, staticRenderFns } from "./tenants.vue?vue&type=template&id=12631714&"
import script from "./tenants.vue?vue&type=script&lang=js&"
export * from "./tenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports